import { ReactQueryMutationError } from "data/mutations-common";
import { ReactQueryQueryError } from "data/queries-common";
import _ from "lodash";
import { UseMutationResult, UseQueryResult } from "@tanstack/react-query";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { OctagonAlert } from "lucide-react";

interface ReactQueryErrorWrapperProps {
  queries?: UseQueryResult<any, unknown>[];
  mutations?: UseMutationResult<any, unknown, any, unknown>[];
}

export const ReactQueryErrorWrapper = (props: ReactQueryErrorWrapperProps) => {
  const isQueryError = _.some(props.queries?.map((query) => query.isError));
  const isMutationError = _.some(
    props.mutations?.map((mutation) => mutation.isError),
  );

  const isError = isQueryError || isMutationError;

  if (!isError) {
    return <></>;
  }

  return (
    <div className="flex flex-col gap-2">
      {props.queries?.map((query) => {
        if (query.isError) {
          return (
            <Alert variant="destructive">
              <OctagonAlert className="size-4" />
              <AlertTitle>
                Something has gone wrong, contact support if the issue persists.
              </AlertTitle>
              <AlertDescription>
                {(query.error as ReactQueryQueryError).message}
              </AlertDescription>
            </Alert>
          );
        }
      })}

      {props.mutations?.map((mutation) => {
        if (mutation.isError) {
          return (
            <Alert variant="destructive">
              <OctagonAlert className="size-4" />
              <AlertTitle>
                Something has gone wrong, contact support if the issue persists.
              </AlertTitle>
              <AlertDescription>
                {(mutation.error as ReactQueryMutationError).message}
              </AlertDescription>
            </Alert>
          );
        }
      })}
    </div>
  );
};
